<template>
    <div class="pt-6 body">
        <div class="d-prose">
            <div class="text-gray-600" v-html="body"></div>    
            <vue-picture v-if="image" :image="image" :style="'rounded-xl'" :width="1000" />
        </div>
        
        <div class="w-full flex flex-wrap md:pt-6" v-if="products">
            <div
                class=""
                v-for="product in products"
                :class="{
                    'w-1/2 force-50': products.length == 2,
                    'w-1/3': products.length == 3,
                    'w-1/4': products.length == 4,
                    'w-1/5': products.length == 5,
                    'w-1/6': products.length == 6,
                }"
                :style="products.length > 5 ? 'width:' + width + '%' : ''"
            >
                <div class="px-4 md:px-0 md:pr-4 flex justify-between flex-col h-full">
                    <div class="relative">
                        <Link
                            :href="product.url"
                            :title="product.name"
                            class="flex items-center hover:opacity-75 px-4 md:px-0"
                        >
                            <VuePicture :image="product.image" :notlazy="true" :style="''" :name="product.name" class="" />
                        </Link>
                        <img
                            :src="product.brandlogo"
                            v-if="product.brandlogo"
                            class="hidden md:block absolute z-10 top-0 right-4 h-6"
                        />
                    </div>
                    <Link
                        :href="product.url"
                        :title="product.name"
                        class="flex items-center hover:opacity-75 px-4 md:px-0"
                    >
                        <h2 class="font-bold">{{ product.name.replace('Cilinderslot', '') }}</h2>
                    </Link>
                    <div class="">
                        <p>
                            <span class="text-base font-medium text-gray-500 mr-2">vanaf</span>
                            <span class="text-base font-bold text-gray-900">{{ price(product.price) }}</span>
                        </p>
                        <Link
                            :href="product.url"
                            :title="product.name"
                            class="px-4 py-2 text-center rounded-md mt-4 button default bg-white block w-full"
                            >Bekijk</Link
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    post: Object,
    body: String,
    image: Object | Boolean,
    products: Object | Boolean,
});
</script>
